
import React from "react";
import { useForm } from 'react-hook-form';
import RFG from "../../libs/inputs/RFG";
import { Box, Typography, Button, Grid, Stack } from "@mui/material";
import ImageEditor from "../../libs/imgcrop/ImageEditor";
import ImageResizer from "../extra/ImageResizer";
import CountrySelect from "../extra/CountrySelect";
import { localCountryCode } from "../../libs/Libs";
import { FormHeroHeader, FormSectionCard, FormFooter, labelStyle } from "../extra/FormLayout";
import { BsCheck2Square } from "react-icons/bs";
import { generateFakeTaskData } from "../../libs/testDataGenerator";

export default function Form({
    title,
    users = [],
    defaultValues = {},
    onSubmit = (data) => { },
    onChange = (column, data) => { },
    back = () => { } }) {
    //let country = defaultValues?.country ? defaultValues.country : localCountryCode()
    const [open, setOpen] = React.useState(false)
    const [checklist, setChecklist] = React.useState([])
    const { handleSubmit, control, setValue, watch, clearErrors, setError, formState: { errors }, } = useForm({ defaultValues: defaultValues, mode: "all" })
    const booleanFields = [
        { name: "verify", label: "Verified", watch: watch("verify") },
        { name: "active", label: "Active", watch: watch("active") },
    ];

    const handleFillFakeData = () => {
        const fakeData = generateFakeTaskData(users);
        Object.entries(fakeData).forEach(([key, value]) => {
            setValue(key, value, { shouldValidate: true });
        });
        clearErrors();
    };

    const showAutoFill = process.env.REACT_APP_DEBUG !== "false" && process.env.REACT_APP_DEBUG !== "False" && process.env.REACT_APP_DEBUG !== "0";

    return (
        <Box sx={{ py: 3, px: { xs: 1, md: 3 }, maxWidth: '1400px', mx: 'auto' }}>
            <FormHeroHeader
                icon={<BsCheck2Square size={26} />}
                title={title || "Task Assignment Setup"}
                subtitle="Assign employee responsibilities, set target due dates, and monitor progress status."
                badgeText="Task Workflow"
            />
            <Box display="flex" justifyContent="flex-end" mb={2.5}>
                {showAutoFill && (
                    <Button
                        data-testid="btn-auto-fill-fake-task"
                        type="button"
                        variant="outlined"
                        onClick={handleFillFakeData}
                        sx={{
                            borderColor: '#10b981',
                            color: '#059669',
                            bgcolor: '#ecfdf5',
                            textTransform: 'none',
                            fontWeight: 700,
                            fontSize: '13px',
                            borderRadius: '20px',
                            px: 2.5, py: 0.8,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            boxShadow: '0 2px 6px rgba(16, 185, 129, 0.15)',
                            '&:hover': { bgcolor: '#d1fae5', borderColor: '#059669', transform: 'translateY(-1px)' }
                        }}
                    >
                        ⚡ Auto-Fill Sample Data
                    </Button>
                )}
            </Box>
            <form
                onSubmit={handleSubmit((data) => {
                    console.log("data submit", data)
                    onSubmit(data)
                })}>
                <FormSectionCard
                    icon={<BsCheck2Square size={20} />}
                    title="Task Parameters & Assignment"
                    subtitle="Set employee ownership, schedule timelines, priority level, and workflow status"
                >
                    <Grid container spacing={3}>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Stack spacing={2.5}>
                                <RFG name="employee" label="Employee *" control={control} labelStyle={labelStyle} rules={{ required: true }}>
                                    <select>
                                        <option value="">Select Employee</option>
                                        {users.map((company) => <option key={company.id} value={company.id}>{company.first_name || company.username}</option>)}
                                    </select>
                                </RFG>
                                <RFG name="start_date" label="Start Date *" control={control} labelStyle={labelStyle} rules={{
                                    required: true
                                }}>
                                    <input type="date" autoComplete="false" />
                                </RFG>

                                <RFG name="target_date" label="Target Due Date *" control={control} labelStyle={labelStyle} rules={{
                                    required: true
                                }}>
                                    <input type="date" autoComplete="false" />
                                </RFG>
                                <RFG name="priority" label="Priority *" control={control} labelStyle={labelStyle} rules={{ required: true }}>
                                    <select>
                                        <option value="">Select Priority</option>
                                        {[
                                            { id: 1, company_name: "Low" },
                                            { id: 2, company_name: "Medium" },
                                            { id: 3, company_name: "High" },
                                        ].map((company) => <option key={company.id} value={company.id}>{company.company_name}</option>)}
                                    </select>
                                </RFG>
                            </Stack>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Stack spacing={2.5}>
                                <RFG name="status" label="Status *" control={control} labelStyle={labelStyle} rules={{ required: true }}>
                                    <select>
                                        <option value="">Select Status</option>
                                        {[{ id: 1, company_name: "Todo" }, { id: 2, company_name: "In - Progress" }].map((company) => <option key={company.id} value={company.id}>{company.company_name}</option>)}
                                    </select>
                                </RFG>

                                <RFG name="description" label="Description *" control={control} labelStyle={labelStyle} rules={{
                                    required: true,
                                    maxLength: {
                                        value: 1000,
                                        message: `Cannot exceed 1000 characters`,
                                    }
                                }}>
                                    <textarea style={{ height: 168 }} autoComplete="false" placeholder="Provide task instructions and deliverables..." rows={6} />
                                </RFG>
                            </Stack>
                        </Grid>
                    </Grid>
                </FormSectionCard>

                <Box display="flex" justifyContent="flex-end" sx={{ mt: 2, mb: 1 }}>
                    {showAutoFill && (
                        <Button
                            data-testid="btn-auto-fill-fake-bottom"
                            type="button"
                            variant="outlined"
                            onClick={handleFillFakeData}
                            sx={{
                                borderColor: '#10b981',
                                color: '#059669',
                                bgcolor: '#ecfdf5',
                                textTransform: 'none',
                                fontWeight: 700,
                                fontSize: '13px',
                                borderRadius: '20px',
                                px: 2.5, py: 0.8,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                boxShadow: '0 2px 6px rgba(16, 185, 129, 0.15)',
                                '&:hover': { bgcolor: '#d1fae5', borderColor: '#059669', transform: 'translateY(-1px)' }
                            }}
                        >
                            ⚡ Auto-Fill Sample Data
                        </Button>
                    )}
                </Box>

                <FormFooter 
                    onCancel={back} 
                    backText="Back" 
                    submitText={defaultValues?.id ? "Update Task" : "Save Task"} 
                    isEdit={!!defaultValues?.id}
                    backTestId="back-task-btn" 
                    saveTestId="save-task-btn" 
                />
            </form>
        </Box>
    );
}